import React from 'react'

interface GradientTextProps {
  children: React.ReactNode
  className?: string
  from?: string
  to?: string
}

export default function GradientText({
  children,
  className = '',
  from = '#F97316',
  to = '#EA580C',
}: GradientTextProps) {
  return (
    <span
      className={`bg-clip-text text-transparent ${className}`}
      style={{
        backgroundImage: `linear-gradient(135deg, ${from} 0%, ${to} 100%)`,
      }}
    >
      {children}
    </span>
  )
}
